import React, { useState, useEffect } from 'react'

const CharacterTile = ({ character, activeCharacterId, parentComponentState, onHandleCharacterClick }) => {
    const [isLoading, setIsLoading] = useState(true)
    const [isActive, setIsActive] = useState(false)
    const characterUuid = character?.uuid
    // const isActive = activeCharacterId === character.uuid

    useEffect(() => {
        if (parentComponentState === 'ANIMATING_IN' || parentComponentState === 'ANIMATING_OUT') {
            setIsLoading(true)
        } else if (parentComponentState === 'ACTIVE') {
            setIsLoading(false)
            if (activeCharacterId === characterUuid) {
                setIsActive(true)
            } else if (activeCharacterId) {
                setIsActive(false)
            }
        }
    }, [parentComponentState, activeCharacterId, characterUuid])

    return (
        <button className={`character-box character-${character.displayOrder} ${isLoading ? 'is-loading' : ''} ${activeCharacterId ? isActive ? 'active' : 'inactive' : ''}`} onClick={() => onHandleCharacterClick(character.uuid)}>
            <div className="background">
                <img src={character.background.url} alt={character.background.alt} />
            </div>
            <div className="middle">
                <img src={character.middleground.url} alt={character.middleground.alt} />
            </div>
            <div className="foreground">
                <img src={character.headshot.url} alt={character.headshot.alt} />
            </div>
            <div className="character-name">
                {character.firstName}<br />
                {character.lastName}
            </div>
        </button>
    )
}

export default CharacterTile
